module.exports = __webpack_public_path__ + "media/images/ic-illustrations-bd3a656dbc03c79ccb93c93d6ecc2243.svg";